import { render, staticRenderFns } from "./bill-qrcode.vue?vue&type=template&id=3be871c0&"
import script from "./bill-qrcode.vue?vue&type=script&lang=js&"
export * from "./bill-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./bill-qrcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports